import Icon, { COLORS, ICONS } from "../../../../general-ui/icon";
import classNames from 'classnames';

interface ISurveyOptionProps {
	selected: boolean;
	percentage: number | null;
	value: string | number;
	onClick: (value: string | number) => void;
	title: string;
	disabled?: boolean;
}

const SurveyOption: React.FC<ISurveyOptionProps> = ({ title, selected, value, percentage, onClick, disabled }) => {

	const handleClick = () => {
		if (!disabled)
			onClick(value);
	};

	return (
		<div className={classNames('survey-option-container')}>
			<button
				className="no-style clear survey-option focus-visible"
				onClick={handleClick}
			>
				<div className="survey-option-progress-bar-container">
					<div className="survey-option-progress-bar" style={percentage ? { width: `${percentage}%` } : { width: 0 }} />
				</div>
				<div className="survey-option-content">
					<div className="survey-option-title">{title}</div>
					<div className="survey-option-check">
						<div style={{ visibility: selected ? 'visible' : 'hidden' }}>
							<Icon name={ICONS.CHECK_CIRCLE_FILLED} color={COLORS.WHITE} size={16} />
						</div>
						<div className="survey-option-percentage-text">{percentage ? `${percentage}%` : ''}</div>
					</div>
				</div>
			</button>
		</div>
	);
};

export default SurveyOption;
